import React from "react"
import ReportsContainer from "../../containers/ReportsContainer/ReportsContainer"

const ReportsPage = () => <ReportsContainer />

export default ReportsPage
